import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { Button, Col, Row } from "antd";
import FormConfigSectionQualifier, {
  IFormConfigSectionQualifier
} from "../../../model/formconfiguration/FormConfigSectionQualifier";
import FormConfigSectionQualifierForm from "./FormConfigSectionQualifierForm";

export interface State {}

export interface UpdateFormConfigSectionQualifierFormProps
  extends FormComponentProps {
  translate: any;
  formConfigSectionQualifier: IFormConfigSectionQualifier;
  updateFormConfigSectionQualifier(
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): Promise<void>;
  Actions: any;
  readOnly: boolean;
}

export default class UpdateFormConfigSectionQualifierForm extends React.Component<
  UpdateFormConfigSectionQualifierFormProps,
  State
> {
  private handleOnChangeEvent = (e) => {
    const {
      formConfigSectionQualifier,
      updateFormConfigSectionQualifier
    } = this.props;
    let updatedFormConfigSectionQualifier = formConfigSectionQualifier;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        updatedFormConfigSectionQualifier.qualifier = {
          ...formConfigSectionQualifier.qualifier,
          ...values
        };

        updatedFormConfigSectionQualifier.qualifier.description =
          values.qualifierDescription;

        updatedFormConfigSectionQualifier = {
          ...updatedFormConfigSectionQualifier,
          ...values
        };
        updateFormConfigSectionQualifier(
          FormConfigSectionQualifier({
            ...updatedFormConfigSectionQualifier
          })
        );
      }
    });
  };
  render() {
    const {
      translate,
      formConfigSectionQualifier,
      Actions,
      readOnly
    } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        {!readOnly && (
          <Row gutter={2} type="flex" justify="end">
            <Col>{Actions}</Col>
            <Col>
              <Button type="primary" onClick={this.handleOnChangeEvent}>
                {translate("qualifier_form.apply_changes")}
              </Button>
            </Col>
          </Row>
        )}

        <FormConfigSectionQualifierForm
          readOnly={readOnly}
          getFieldDecorator={getFieldDecorator}
          translate={translate}
          formConfigSectionQualifier={formConfigSectionQualifier}
        />
      </div>
    );
  }
}
